import React, {useEffect, useState} from "react";
import {Row} from "react-bootstrap";
import MachineModelEditFormConfig from "./MachineModelEditFormConfig";
import CardForm from "../../components/form/CardForm";
import {hasAdminPanelFullAccess, hasPackagingLinesFullAccess} from "../../helpers/jwt";
import FunctionalTableComponent from "../../components/table/FunctionalTableComponent";
import CategoryTableConfig from "./CategoryTableConfig";
import CategoryFormConfig from "./CategoryFormConfig";
import FormatPartTableConfig from "./FormatPartTableConfig";
import FormatPartFormConfig from "./FormatPartFormConfig";
import { useTranslation } from 'react-i18next';

export function MachineModel(props) {
    const { t } = useTranslation();

    const [selectedCategory, setSelectedCategory] = useState();
    const [initialized, setInitialized] = useState(false);
    const [formatPartsReady, setFormatPartsReady] = useState(false);



    function reInit() {
        setInitialized(false)
    }

    function initialize() {
        if (!initialized) {
            setInitialized(true)
        }
    }


    function categorySelected() {
        if (!!selectedCategory) {
            setFormatPartsReady(true)
        }
    }


    useEffect(initialize, [initialized])
    useEffect(categorySelected, [selectedCategory])

    return <>
        {initialized &&
            <Row>
                <CardForm
                    // title={renderUtils.renderMachineType(props.machineModel)}
                    title={t("object_types.machine_model")}
                    setLoader={props.setLoader}
                    fields={MachineModelEditFormConfig}
                    width={props.width || 4}
                    qrCodeValue={props.machineModel.id}
                    initialData={props.machineModel}
                    editable={props.editable !== false}
                    readOnly={props.readOnly}
                    api={"machine-model/" + props.machineModel.id}
                    disableCleanAfterSave={true}
                    reInit={reInit}
                    performReload={() => props.setReload(!props.reload)}
                    hideIfNull={true}
                />
                {
                    <FunctionalTableComponent
                        title={t("common.categories")}
                        columns={CategoryTableConfig}
                        header={true}
                        api={"format-part-category/by-machine-model/" + props.machineModel.id}
                        setLoader={props.setLoader}
                        readOnly={props.readOnly || !hasPackagingLinesFullAccess()}
                        removable={true}
                        editable={true}
                        width={4}
                        tableHeader={false}
                        pagination={false}
                        editWithId={true}
                        setExternalReload={props.setReload}
                        externalReload={props.reload}
                        createApi={"format-part-category"}
                        editApi={"format-part-category"}
                        deleteApi={"format-part-category"}
                        creationFields={CategoryFormConfig(props.machineModel.id, t)}
                        creationTitle={t("common.new_category")}
                        deleteModalTitle={t("forms.category_deletion")}
                        deleteModalDescription={t("forms.confirm_category_deletion")}
                        externalState={selectedCategory}
                        setExternalState={setSelectedCategory}
                        actionsInEnd={true}

                    />
                }
                {formatPartsReady && selectedCategory &&
                    <FunctionalTableComponent
                        title={t("common.format_parts")}
                        columns={FormatPartTableConfig}
                        header={true}
                        actionsInEnd={true}
                        api={"formatPart/by-category/" + selectedCategory.category.id}
                        setLoader={props.setLoader}
                        readOnly={props.readOnly ||!hasPackagingLinesFullAccess()}
                        removable={true}
                        editable={true}
                        editWithId={true}
                        width={4}
                        tableHeader={false}
                        pagination={false}
                        setExternalReload={props.setReload}
                        externalReload={props.reload}
                        createApi={"formatPart"}
                        editApi={"formatPart"}
                        deleteApi={"formatPart"}
                        creationFields={FormatPartFormConfig(selectedCategory.category.id, props.machineModel.id, t)}
                        creationTitle={t("forms.new_format_part")}
                        deleteModalTitle={t("forms.format_part_deletion")}
                        deleteModalDescription={t("forms.confirm_format_part_deletion")}
                        externalState={selectedCategory}
                        setExternalState={setSelectedCategory}
                    />
                }
            </Row>
        }
    </>;
}